export enum SportStrings {
  Football = 'Football',
  Darts = 'Darts',
  Tennis = 'Tennis'
}

export enum SportIDs {
  AmericanFootball = 7,
  Bandy = 14,
  Baseball = 6,
  Basketball = 5,
  Boxing = 19,
  Cricket = 46,
  Cycling = 8,
  Darts = 50,
  Esports = 67,
  Football = 1,
  Futsal = 51,
  Golf = 9,
  Handball = 2,
  Hockey = 24,
  IceHockey = 4,
  Rugby = 12,
  Tennis = 3,
}

export const isTeam = (sportId: number): boolean => ![SportIDs.Darts, SportIDs.Tennis].includes(sportId);
